import React from 'react';
import ReactDOM from 'react-dom/client';
import RTer from './router';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RTer />
  </React.StrictMode>
);
